module.exports = __webpack_public_path__ + "img/ปลาเฮค.ff5fed9e.jpg";